module.exports = __webpack_public_path__ + "static/media/Team 12 - Mini Minds.6d1f5f93.png";